import filterTokens from '@amzn/meridian-tokens/base/icon/filter';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import SearchField from '@amzn/meridian/search-field';
import Tooltip from '@amzn/meridian/tooltip';
import React from 'react';
import { useDispatch } from 'react-redux';
import { setIsAdvancedFilterSheetOpen } from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import {
  setIsCreateModalOpen,
  setSearchField,
} from 'src/store/adminConfigPageSlice/siteConfigPageSlice/siteConfigPageSlice';
import { useAppSelector } from 'src/store/store';

const TopOptions = () => {
  const dispatch = useDispatch();
  const { searchField } = useAppSelector((state) => state.siteConfigPage);
  return (
    <Row widths={['85%', '15%']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width={'grid-4'}>
        <SearchField
          value={searchField}
          onChange={(newSearchField) => dispatch(setSearchField(newSearchField))}
          placeholder="Search for..."
          onSubmit={() => {}}
          data-cy="site-input-search"
        />
        <Tooltip position="top" title="Open Site Configuration Filter">
          <div
            className="hover-icon-wrapper"
            onClick={() => {
              dispatch(setIsAdvancedFilterSheetOpen(true));
            }}
            aria-label="Filter Sites"
          >
            <Icon tokens={filterTokens} />
          </div>
        </Tooltip>
      </Row>

      <Button id="site-config-top-options-open-modal" onClick={() => dispatch(setIsCreateModalOpen(true))}>
        Add New Site
      </Button>
    </Row>
  );
};

export default TopOptions;
